import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-800.css';
import * as Sentry from '@sentry/react';

const SENTRY_DSN = 'https://38fb2530bfbb1fb75b0cc098b5bd9b83@o361932.ingest.us.sentry.io/4510895878307840';
const VITE_ENV = import.meta.env.VITE_ENV || 'other';

Sentry.init({
  enabled: !import.meta.env.DEV,
  dsn: SENTRY_DSN,
  environment: VITE_ENV
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
